import { render, staticRenderFns } from "./Cupons.vue?vue&type=template&id=c5a52b6e&scoped=true&"
import script from "./Cupons.vue?vue&type=script&lang=js&"
export * from "./Cupons.vue?vue&type=script&lang=js&"
import style0 from "./Cupons.vue?vue&type=style&index=0&id=c5a52b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a52b6e",
  null
  
)

export default component.exports